import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Artifact } from '../artifact.js';
import { linkStyles } from './cssstyles.js';

@customElement('video-attachment')
class VideoAttachment extends LitElement {
  @property({ attribute: false }) artifact?: Artifact;

  override render() {
    const artifact = this.artifact;
    if (!artifact)
      return nothing;
    return html`
      <v-box class=wrapper>
        <video class="player dropshadow" controls preload=metadata>
          <source src=${artifact.url} type=${artifact.contentType}>
        </video>
        <h-box class=caption>
          <span class=filename>${artifact.fileName}</span>
          <a class=download href=${artifact.url} download=${artifact.fileName}>
            <sl-icon name=download></sl-icon>
          </a>
        </h-box>
      </v-box>
    `;
  }

  static styles = [linkStyles, css`
    :host {
      display: block;
    }

    .wrapper {
      gap: var(--sl-spacing-x-small);
      align-items: flex-start;
    }

    .player {
      width: 100%;
      max-width: var(--video-attachment-max-width, 500px);
      border-radius: var(--sl-border-radius-large);
    }

    .dropshadow {
      box-shadow: 0 0 4px 0px var(--sl-color-neutral-400);
    }

    .caption {
      gap: var(--sl-spacing-2x-small);
      align-items: center;
      font-size: var(--sl-font-size-small);
    }

    .filename {
      font-family: var(--sl-font-mono);
    }

    .download {
      display: inline-flex;
      align-items: center;
      color: var(--sl-color-neutral-600);
    }

    .download:hover {
      color: var(--sl-color-primary-600);
    }
  `];
}
